import gql from 'graphql-tag';

import { PAGINATION_FRAGMENT } from './paginationFragment';
import { DEAL_SHEET_CONFIGURATION_FRAGMENT } from './configurationFragment';

export const GET_DEAL_SHEET_TABLE_CONFIGURATIONS = gql`
  query DealSheetTableConfigurations($input: DealSheetTableConfigurationsInput!) {
    dealSheets {
      result: dealSheetTableConfigurations(input: $input) {
        success
        error
        pagination {
          ...Pagination
        }
        items {
          ...DealSheetConfig
        }
      }
    }
  }
  ${PAGINATION_FRAGMENT}
  ${DEAL_SHEET_CONFIGURATION_FRAGMENT}
`;
